var React = require('react');

function Adjustments (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"}));
}

Adjustments.defaultProps = {"viewBox":"0 0 20 20","fill":"currentColor"};

module.exports = Adjustments;

Adjustments.default = Adjustments;
